export const empty = (element: Element | string) => {
  const target = typeof element === 'string' ? document?.querySelector(element) : element;
  while (target?.firstChild) {
    target?.firstChild?.remove();
  }
};
